import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { greeting } from "../../portfolio.js";
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  return (
    <div className="footer-div">
      <Fade>
        <p className="footer-text" style={{ color: props.theme.secondaryText }}>
          Built with code, coffee, and love by {greeting.title2}{" "}
          <span role="img">☕❤️</span>
        </p>
      </Fade>
    </div>
  );
}
